<template>
  <div class="footerWrap">
    <div class="footer" v-if="isPC">
      <div class="content-wrap">
<!--        <div class="logo-image">-->
<!--          <img :src="logo"/>-->
<!--        </div>-->
        <div class="item-wrap">
<!--          <div><span>网络经营许可证</span></div>-->
<!--          <div class="line"></div>-->
<!--          <div><span>儿童隐私政策</span></div>-->
<!--          <div class="line"></div>-->
<!--          <div><span>ICP证书</span></div>-->
<!--          <div class="line"></div>-->
          <div><span @click="switchFooter('/businessLicense')">营业执照</span></div>
        </div>
        <div class="item-wrap">
          <div><a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_blank">{{icpText}}</a></div>
          <div class="line"></div>
<!--          <div><span @click="switchFooter('/publications')">出版物经营许可证</span></div>-->
        </div>
<!--        <div class="address">-->
<!--&lt;!&ndash;          <div class="contact-address"><span class="iconfont icon-youxiang"></span>Email: bjwl@xdf.cn</div>&ndash;&gt;-->
<!--          <div class="contact-address">新媒体平台资质审核电话: 010-60908000-8941</div>-->
<!--        </div>-->
        <div class="item-wrap">
          <div><span>苏州东方创科科技有限公司</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isPC } from '@/utils/getIsPC'
let logo = require('../../assets/newImage/footerLogo.png')
export default {
  data () {
    return {
      isPC: true,
      logo,
      icpText: ''
    }
  },
  created () {
    this.isPC = isPC()
    let hostArr = window.location.host.split('.')
    let domain = hostArr[hostArr.length - 1]
    if (domain === 'com') this.icpText = '苏ICP备2021039264号'
    if (domain === 'cn') this.icpText = '苏ICP备2021039264号'
  },

  methods: {
    switchFooter (url) {
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 1366px){
  .footer .content-wrap {
    max-width: 1080px;
  }
}
@media screen and (min-width: 1680px){
  .footer .content-wrap {
    max-width: 1280px;
  }
}
.footer {
  box-sizing: border-box;
  background-color: #f8f8f8;
  padding: 20px 0;
  font-size: 13px;
  color: #7f7f7f;
  text-decoration: none;
  line-height: 24px;
  .content-wrap{
    width: 100%;
    margin: 0 auto;
  }
  .logo-image{
    display: flex;
    img{
      height: 80px;
    }
    font-size: 18px;
  }
  .item-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      padding: 0 8px;
    }
    .line{
      padding: 0;
      width: 1px;
      background-color: rgba(255,255,255,0.8);
      height: 13px;
    }
    span{
      cursor: pointer;
    }
  }
  .address{
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      display: flex;
      align-items: center;
      padding: 0 15px;
      span{
        margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/footer.vue